/* eslint-disable no-unused-vars */

export enum FeaturesIconEnum {
    Animation = 'animation',
    BlankSpacer = 'blankspacer',
    Chat = 'chat',
    Content = 'content',
    DevTools = 'devtools',
    Gameplay = 'gameplay',
    IntegratedMedia = 'integratedmedia',
    Line = 'line',
    Pipeline = 'pipeline',
    PlatformSupport = 'platformsupport',
    Rendering = 'rendering',
    SourceCode = 'sourcecode',
    Vfx = 'vfx',
    WorldBuilding = 'worldbuilding'
}
